import React from "react";

import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";
import { Aed } from "../../../common/Money";
import {
  MEMBERSHIP_ANNUAL,
  MEMBERSHIP_MONTHLY,
  PLAN_YEARLY,
  PROFILE_WINDOW_DAYS,
  WEB_PROFILE_MEMBER,
  WEB_PROFILE_STANDARD,
} from "../../../../constants/webProfilePricing";
import { PlanOptionCard } from "./PlanOptionCard";
import { MembershipTermToggle } from "./MembershipTermToggle";
import {
  MEMBERSHIP_FEATURES,
  PROFILE_FEATURES,
  membershipTermLabel,
  membershipTermSuffix,
} from "./planFields";

/* The left column of /u1/plans: what there is to buy, and the two actions. */
export const PlanChoices = ({
  isMember,
  canJoin = true,
  mode,
  setMode,
  plan,
  selectBundlePlan,
  onContinue,
  onCancel,
  className = "",
}) => (
  <div className={className}>
    {isMember ? (
      <PlanOptionCard
        title="Web Profile"
        description="Your active membership unlocks the Member rate on this purchase."
        features={PROFILE_FEATURES}
        badge="Member rate applied"
        /* Nothing to choose: the rate is already theirs. */
        selectable={false}
        selected
        price={<Aed value={WEB_PROFILE_MEMBER} />}
        priceSuffix={`/ ${PROFILE_WINDOW_DAYS} days`}
        strikePrice={<Aed value={WEB_PROFILE_STANDARD} />}
      />
    ) : (
      <div className="grid grid-cols-1 items-stretch gap-4 md:grid-cols-2">
        <PlanOptionCard
          id="u1-plan-payg"
          title="Web Profile"
          description={`Standard rate. Pay once, ${PROFILE_WINDOW_DAYS} days of full access.`}
          features={PROFILE_FEATURES}
          selected={mode === "payg"}
          onSelect={() => setMode("payg")}
          price={<Aed value={WEB_PROFILE_STANDARD} />}
          priceSuffix={`/ ${PROFILE_WINDOW_DAYS} days`}
          footnote="One-time purchase"
        />

        <PlanOptionCard
          id="u1-plan-bundle"
          title="Web Profile + Membership"
          description="Pay the Member rate. Membership unlocks the rate on every TREVEX product."
          features={MEMBERSHIP_FEATURES}
          ribbon="Save with Membership"
          selected={canJoin && mode === "bundle"}
          disabled={!canJoin}
          note={
            canJoin
              ? undefined
              : "Membership belongs to a business. Claim yours first, then the Member rate is available on every purchase."
          }
          tooltip={
            canJoin
              ? undefined
              : "To purchase Membership, you must claim your business profile first."
          }
          onSelect={() => setMode("bundle")}
          price={<Aed value={WEB_PROFILE_MEMBER} />}
          priceSuffix={`/ ${PROFILE_WINDOW_DAYS} days`}
        >
          <MembershipTermToggle
            className="mt-3.5"
            value={plan}
            onChange={selectBundlePlan}
          />

          {/* The membership is charged on top of the profile, and the live
              screen says so in as many words. */}
          <p className="m-0 mt-3 inline-flex flex-wrap items-center gap-1 text-[11.5px] leading-[1.5] text-[var(--muted)] font-sans">
            +{" "}
            <Aed value={plan === PLAN_YEARLY ? MEMBERSHIP_ANNUAL : MEMBERSHIP_MONTHLY} />
            /{membershipTermSuffix(plan)} — {membershipTermLabel(plan)}
          </p>
        </PlanOptionCard>
      </div>
    )}

    <div className={cn("mt-6 flex items-center justify-end gap-3")}>
      <Button variant="ghost" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="coralSolid" className="px-6" onClick={onContinue}>
        Continue
      </Button>
    </div>
  </div>
);

export default PlanChoices;
